import { createAction } from 'redux-actions';
export const clearApplicant = createAction('CLEAR_APPLICANT');
export const clearApplicationEnvironment = createAction('CLEAR_APPLICATION_ENVIRONMENT');
export const setPersonalInfo = createAction('CREDIT_APPLICATION/SET_PERSONAL_INFO');
export const setPersonalInfoOTA = createAction('CREDIT_APPLICATION/SET_PERSONAL_INFO_OTA');
export const setApplicationEnvironment = createAction('SET_APPLICATION_ENVIRONMENT');
export const setPractice = createAction('CREDIT_APPLICATION/SET_PRACTICE');
export const setCreditApplication = createAction('SET_CREDIT_APPLICATION');
